import { QueryResponse } from 'api/queries/getWbs.query';
export const mapper = (
    item: QueryResponse,
): { id: number; label: string; value: { value: string; wbs_level: number } } => {
    const label = `${item.name} (ID: ${item.activity_id})`;
    return {
        id: item.id,
        label: label,
        value: {
            value: String(item.id),
            wbs_level: item.wbs_level,
        },
    };
};
